export enum $academyUser {
  tenantId = 'tenantId',
  userId = 'userId',
  roles = 'roles',
  _id = '_id',
  user = 'user',
  disabled = 'disabled',
  externalUserId = 'externalUserId',
}

export enum AcademyUserRole {
  learner = 'learner',
  manager = 'manager',
}
